import { useQuery } from '@tanstack/react-query';
import { recallReportService } from '@/services';
import { queryKeys } from '@/services/query-keys';

export const useRecallReportDetail = (id: number | null) => {
  return useQuery({
    queryKey: queryKeys.recallReport.detail(id!),
    queryFn: () => recallReportService.getRecallReportDetail(id!),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: id !== null,
  });
};
